export default __webpack_public_path__ + "static/media/img-error-purple.4f6e0ced.svg";